import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'green' | 'terracotta';
}
export function CTAButton({
  children,
  onClick,
  className = '',
  variant = 'green'
}: CTAButtonProps) {
  const variants = {
    green: 'bg-brand-green hover:bg-brand-terracotta focus-visible:ring-brand-green',
    terracotta: 'bg-brand-terracotta hover:bg-brand-green focus-visible:ring-brand-terracotta'
  };
  return <button type="button" onClick={onClick} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-[0_8px_20px_rgba(46,42,38,0.14)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_25px_rgba(46,42,38,0.18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${variants[variant]} ${className}`} data-id="element-39" data-mp="2tx9wipz7pq4k">
      {children}
    </button>;
}